// VoK MUI base styles
import colors from "app/assets/theme-dark/base/colors";
import boxShadows from "app/assets/theme-dark/base/boxShadows";
import borders from "app/assets/theme-dark/base/borders";

const {background} = colors;
const {cardBoxShadow} = boxShadows;
const {borderRadius} = borders;

const tableContainer = {
    styleOverrides: {
        root: {
            backgroundColor: background.dark,
            boxShadow: cardBoxShadow,
            borderRadius: borderRadius.xl,
        },
    },
};

export default tableContainer;
